import { Checkbox, Typography } from '@garner-health/components-common';
import { SR } from '@garner-health/lib-ui-content-management';
import React from 'react';

export const DisciplinaryActionValidation = ({ isProfessional }: { isProfessional: boolean }) => {
  const labelId = isProfessional ? 'disciplinaryActionCheck' : 'facilityDisciplinaryActionCheck';

  return (
    <Checkbox
      name="isReportingDisciplinaryAction"
      label={
        <Typography variant="button">
          <SR package="suggestEditDialog" id={labelId} />
        </Typography>
      }
    />
  );
};
